import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { _windowUtil } from "src/app/shared/utils/ui-utils";
import { properties } from 'src/environments/properties';

@Component({
  selector: 'app-confirmation-notifications',
  templateUrl: './confirmation-notifications.component.html',
  styleUrls: ['./confirmation-notifications.component.scss']
})
export class ConfirmationNotificationsComponent  {

  @Input() userSubscriptionDetails: any;
  @Input() subscriptionStatus: string;
  @Input() status: string;
  @Input() hasCoupons: boolean;

  public windowUtil = _windowUtil(window);
  snapFlagEnabled: boolean = properties.featureFlags.enableSnap;
  suspendedGovAssistance: boolean = false;
  isSuspended: boolean = false;
  isSecondaryFreshpassUserSuspended: boolean = false;

  suspendedGovElibilityText: string = properties.freshpassData.suspendedGovElibilityText;
  govAssistanceElibilityText: string = properties.freshpassData.govAssistanceElibilityText;
  snapVerificationURL_UCA: string = properties.snapVerificationURL_UCA;
  suspendedSecondaryUserPrompt: string = properties.freshpassData.suspendedSecondaryUserPrompt;

  constructor(private router: Router) { }



  ngOnChanges(): void {
    this.checkAndSetSuspendedStatus();
  }

  checkAndSetSuspendedStatus() {
    if (this.subscriptionStatus === "SUSPENDED" ||
      (this.subscriptionStatus === 'PENDING_ACTIVATION' && this.status === 'Suspended')) {
        this.isSuspended = true;
        if (this.snapFlagEnabled && this.userSubscriptionDetails?.isPromoExpired && this.userSubscriptionDetails?.promoInfo) {
          this.suspendedGovAssistance = true;
        }
        if(this.userSubscriptionDetails?.isPrimaryFreshPassUser === false) {
          this.isSecondaryFreshpassUserSuspended = true;
        }
    }
  }

  redirectToPayments() {
    this.router.navigate(["/freshpass/manage"]);
  }

  redirectToSnapVerification() {
    this.windowUtil.setWindowLocationHref(
      this.snapVerificationURL_UCA
    );
  }
}
